<div class="sub-system-container">
    <div class="sub-system-header">
        <div class="d-flex flex-row justify-content-between">
            <h3>
                {{ 'Translation'|translate }}
                <label *ngIf="isReadOnly"><i class="fa fa-glasses text-muted small ml-2"></i></label>
            </h3>
            <div class="btn-group sub-system-header-actions d-flex flex-wrap" role="group" aria-label="LanguageSelection">
                <button class="btn btn-outline-secondary" *ngIf="mayDeleteUnusedTranslations" (click)="deleteUnusedTranslations()"><i class="mr-2 fa fa-broom text-danger"></i>Delete unused translations</button>
                <button class="btn btn-outline-secondary"
                        *ngIf="this.translationTrackingService.untranslatedKeys.size"
                        (click)="filterOnUntranslatedKeys=!filterOnUntranslatedKeys; updatePagedServiceTranslations()">
                    <i class="fas" [class.fa-eye-slash]="!filterOnUntranslatedKeys" [class.fa-eye]="filterOnUntranslatedKeys"></i>
                    {{'FilterOnUntranslated'|translate}}</button>
                <div ngbDropdown class="btn-group">
                    <button ngbDropdownToggle class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img src="./assets/flag-icons/flags/flag-{{currentReferenceLanguage.flagClass}}.png" height="16" alt="{{currentReferenceLanguage.label|translate}}" class="mr-2"/>{{ 'referenceLanguage'|translate }}<i class="fa fa-caret-down ml-2"></i>
                    </button>
                    <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <ng-container *ngFor="let language of languages">
                            <button class="dropdown-item text-secondary mini" type="button" (click)="selectReferenceLanguage(language)">
                                <img src="./assets/flag-icons/flags/flag-{{language.flagClass}}.png" height="16" alt="{{language.label|translate}}" class="mr-2"/>
                                {{ language.label|translate }}
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div ngbDropdown class="btn-group">
                    <button ngbDropdownToggle class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img src="./assets/flag-icons/flags/flag-{{currentTranslationLanguage.flagClass}}.png" height="16" alt="{{currentTranslationLanguage.label|translate}}" class="mr-2"/>{{ 'translationLanguage'|translate }}<i class="fa fa-caret-down ml-2"></i>
                    </button>
                    <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <ng-container *ngFor="let language of languages">
                            <button class="dropdown-item text-secondary mini" type="button" (click)="selectTranslationLanguage(language)">
                                <img src="./assets/flag-icons/flags/flag-{{language.flagClass}}.png" height="16" alt="{{language.label|translate}}" class="mr-2"/>
                                {{ language.label|translate }}
                            </button>
                        </ng-container>
                    </div>
                </div>

                <button class="btn btn-outline-primary" (click)="reload()"><i class="fa fa-refresh"></i></button>
            </div>
        </div>
    </div>
    <div class="sub-system-content">
        <div class="paginated-table-panel">
            <cdk-table [hidden]="!translations"
                       #translationsTable
                       matSort
                       multiTemplateDataRows
                       class="list-table compact-mat-table"
                       [dataSource]="pagedDataService.pagedData"
                       (matSortChange)="pagedDataService.sortData($event)">

                <ng-container matColumnDef="edit" *ngIf="isReadOnly">
                    <th mat-sort-header *matHeaderCellDef></th>
                    <td mat-cell class="ellipsis icon-column" *matCellDef="let translation"></td>
                </ng-container>

                <ng-container matColumnDef="edit" *ngIf="!isReadOnly">
                    <th mat-sort-header *matHeaderCellDef></th>
                    <td mat-cell class="ellipsis icon-column" *matCellDef="let translation" (click)="editTranslation(translation); $event.stopPropagation()"><i class="fa fa-edit text-primary clickable"></i></td>
                </ng-container>

                <ng-container matColumnDef="inUse">
                    <th mat-sort-header *matHeaderCellDef></th>
                    <td mat-cell class="ellipsis icon-column" *matCellDef="let translation"><i class="fa fa-check text-success" *ngIf="typed(translation).isInUse" [title]="'Latest use: ' + (typed(translation).latestUse | date:'shortDate')"></i></td>
                </ng-container>

                <ng-container matColumnDef="key">
                    <th mat-sort-header *matHeaderCellDef> {{ 'translationKey'|translate }}</th>
                    <td mat-cell class="ellipsis fill-column-25" title="{{typed(translation).key}}" *matCellDef="let translation">{{ typed(translation).key }}</td>
                </ng-container>

                <ng-container matColumnDef="referenceText">
                    <th mat-sort-header *matHeaderCellDef>{{ currentReferenceLanguage.label|translate }}<label class="ml-2 text-muted">({{ numberOfUntranslatedReferenceTexts() }})</label></th>
                    <td mat-cell class="ellipsis fill-column-25" title="{{typed(translation).referenceText}}" *matCellDef="let translation"
                        [class.table-danger]="!typed(translation).isReferenceTranslated && currentReferenceLanguage.languageCode == 'en-GB'">{{ typed(translation).referenceText }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="translationText">
                    <th mat-sort-header *matHeaderCellDef>{{ currentTranslationLanguage.label|translate }}<label class="ml-2 text-muted">({{ numberOfUntranslatedTranslationTexts() }})</label></th>
                    <td mat-cell class="ellipsis fill-column-25" title="{{typed(translation).translationText}}" *matCellDef="let translation" [class.table-warning]="!typed(translation).isTranslated">{{ typed(translation).translationText }}</td>
                </ng-container>

                <ng-container matColumnDef="sourceUrl">
                    <th mat-sort-header *matHeaderCellDef>{{ 'Source'|translate }}</th>
                    <td mat-cell class="ellipsis fill-column-25"
                        title="{{typed(translation).sourceUrl}}"
                        *matCellDef="let translation">

                        <a *ngIf="isUrl((typed(translation).sourceUrl))" href="{{toUrl(typed(translation).sourceUrl)}}" target="_blank" (click)="$event.stopPropagation()">
                            {{ typed(translation).sourceUrl }}
                        </a>

                        <label *ngIf="!isUrl((typed(translation).sourceUrl))">{{ typed(translation).sourceUrl }}</label>
                    </td>
                </ng-container>

                <ng-container matColumnDef="delete" *ngIf="isReadOnly || !userRolePermissionsService.isAdmin()">
                    <th mat-sort-header *matHeaderCellDef></th>
                    <td mat-cell class="ellipsis icon-column" *matCellDef="let translation"></td>
                </ng-container>

                <ng-container matColumnDef="delete" *ngIf="!isReadOnly && userRolePermissionsService.isAdmin()">
                    <th mat-sort-header *matHeaderCellDef></th>
                    <td mat-cell class="icon-column" *matCellDef="let translation" (click)="deleteTranslation(translation); $event.stopPropagation()"><i class="fa fa-trash-alt clickable" [class.text-danger]="typed(translation).isInUse" [class.text-success]="!typed(translation).isInUse"></i></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnDefinitions" #translationsTableHeaderRow></tr>
                <tr mat-row *matRowDef="let translation; columns: columnDefinitions;" #translationsTableRow (click)="editTranslation(translation); $event.stopPropagation()"></tr>

            </cdk-table>

            <filter-pagination [pagedDataService]="pagedDataService" [hidden]="!translations || translations.length == 0"></filter-pagination>
        </div>
    </div>
</div>
